module.exports = __webpack_public_path__ + "img/2500f.dc23d4eb.png";